import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { register, unregister } from "../../domain/socketSlice";
import { api } from "../../maps/data.js";
import { colors } from "../../maps/colors";
import TempCart from "/src/components/floor/cart";

const PreviewStyled = styled.div`
  // position: absolute;
  bottom: 5px;
  background-color: rgba(204, 204, 204, 0.614);
  right: 5px;
`;

const WrapperStyled = styled.div`
  padding: 5px;
  position: relative;
  height: 100%;
`;

const PaintBoxStyled = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  cursor: grab;
`;

const FloorStyled = styled.div`
  background: ${colors.WHITE};
  margin: 0px;
  position: relative;
`;

import PropTypes from "prop-types";

// FloorPage.propTypes = {
//   siteId: PropTypes.string.isRequired,
// };
const STALE_TIME = 3000; // 3 seconds

export default function FloorPage(props) {
  const { siteId } = { siteId: "66f11d80c8adb8d1ed21ae0e" };
  const [edges, setEdges] = useState([]);
  const [floorFields, setFloorFields] = useState([]);

  const [selectedRoute, setSelectedRoute] = useState(null);
  const [shopperIds, setShopperIds] = useState([]);

  const eventName = `play-mode-data-${siteId}`;
  // const eventName = `play-mode-data-66f11d80c8adb8d1ed21ae0e`;

  const eventStats = useRef({});
  const [detections, setDetections] = useState([]);

  // if (siteId == null) return;

  useEffect(() => {
    register(eventName);
    window.addEventListener(eventName, onFloorData);
    window.c = 0;

    return () => {
      unregister(eventName);
      window.removeEventListener(eventName, onFloorData);
    };
  }, []);

  useEffect(() => {
    fetchEdges(siteId);

    console.log(edges);
  }, []);

  useEffect(() => {
    if (edges.length === 0) return;
    const e = edges.filter(
      (edge) => edge._id === "670b909553bffca72d369d01"
    )[0];

    handleEdgeClick(e);
  }, [edges]);

  ("");
  useEffect(() => {
    const handleShopperIdsChange = () => {
      console.log("shopperIds updated:", shopperIds);
      // Add any additional logic here, e.g., updating another state
    };

    handleShopperIdsChange();
  }, [shopperIds]); // Triggered when shopperIds changes

  const fetchEdges = async (siteId) => {
    try {
      const res = await api({ type: "getEdges", data: { siteId } });
      setEdges(res);
      localStorage.setItem(`edges_${siteId}`, JSON.stringify(res));
    } catch (err) {
      console.error("Failed to fetch edges:", err);
      setError("Unable to fetch edges. Please try again later.");
    }
  };

  useEffect(() => {
    // console.log("floorFields", floorFields);
  }, [floorFields]); // Triggered when shopperIds changes

  const handleEdgeClick = (edge) => {
    // debugger;
    setSelectedRoute(edge);
    // debugger
    setFloorFields(edge.floor.floorEdgeFields);
  };

  const onFloorData = async (floorData) => {
    if (!floorData?.detail) return;

    const { type, data } = floorData.detail;

    if (type === "shoppersDetection") {
      setDetections((prevDetections) => {
        const updatedDetections = { ...prevDetections };

        data.forEach((detection) => {
          updatedDetections[detection.id] = {
            ...updatedDetections[detection.id], // Preserve previous data
            ...detection, // Merge new data
            lastUpdated: Date.now(), // Add/update timestamp
          };
        });

        return updatedDetections;
      });
    }
  };

  // Remove stale detections
  useEffect(() => {
    const interval = setInterval(() => {
      setDetections((prevDetections) => {
        const now = Date.now();
        const filteredDetections = Object.fromEntries(
          Object.entries(prevDetections).filter(
            ([, detection]) => now - detection.lastUpdated < STALE_TIME
          )
        );
        return filteredDetections;
      });
    }, 2000); // Check every 2 seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <div className="flex w-screen h-screen">
      {/* First Column (3/4 of the screen) */}
      <div className="w-full bg-blue-100 p-4">
        <div className="relative">
          <div
            style={{
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              position: "absolute",
            }}
          ></div>
          <div className="absolute" style={{ zIndex: "200" }}>
            {edges.map((edge, index) => (
              <button
                key={index}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-800 transition"
                onClick={() => handleEdgeClick(edge)}
              >
                {edge.floorName || `Edge ${index + 1}`}
              </button>
            ))}
          </div>

          {selectedRoute && (
            <div className="relative bg-white  overfl ow-hidden rounded-lg border bg-red">
              <div
                className="relative h-full w-full bg-white"
                style={{
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  width: `${selectedRoute.floor.width}px`,
                  height: `${selectedRoute.floor.height}px`,
                  background: `#fff url(${selectedRoute.floor.imageMetadata.url}) no-repeat left top`,
                  // backgroundSize: "cover",
                  // backgroundPosition: "-60px 0",
                  // minHeight: "100vh",

                  // backgroundSize: '100% 100%'
                  // paddingLeft: "40px",
                }}
              >
                {selectedRoute.floor.imageMetadata.url && (
                  <img
                    src={selectedRoute.floor.imageMetadata.url}
                    alt={selectedRoute.floorName}
                    className="absolute left-0 top-0 h-full w-full object-contain"
                  />
                )}

                {floorFields.map((field, index) => {
                  return (
                    <div
                      key={index}
                      className={`absolute transition-all duration-7 flex items-center justify-center text-white  bg-slate-700 opacity-85		`}
                      style={{
                        // top: `${
                        //   (field.yFactor / selectedRoute.floor.height) * 101
                        // }%`,
                        // left: `${
                        //   (field.xFactor / selectedRoute.floor.width) * 101
                        // }%`,
                        top: `${field.yFactor}px`,
                        left: `${field.xFactor}px`,

                        width: `${field.field.width}px`,
                        height: `${field.field.height}px`,
                        // background: "red",
                        zIndex: 100,
                        outlineOffset: "-1px",
                        marginBottom: "10px",
                        transform: `rotate(  ${field.rotate}deg)` /* Equal to rotateZ(45deg) */,
                      }}
                    >
                      <span className="opacity-100 font-black		">
                        {field.field.name}
                        {/* {field.field.width} */}
                        {console.log(field)}

                        {/* {field.yFactor / selectedRoute.floor.width} */}
                      </span>
                    </div>
                  );
                })}

                {Object.values(detections).map((detection) => (
                  <div
                    key={detection.id}
                    className="absolute h-10 w-10 rounded-full transition-all duration-75"
                    style={{
                      top: `${detection.position.y}px`,
                      left: `${detection.position.x}px`,
                      backgroundColor: detection.color || "red",
                      zIndex: 500,
                    }}
                  >
                    <span
                      className="absolute text-lg font-bold text-white bg-black px-2 py-1 rounded"
                      style={{ top: "-15px", right: "-15px" }}
                    >
                      {detection.id}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Second Column (1/4 of the screen) */}
      <div
        className="w-1/6 bg-gray-800 p-4"
        style={{ position: "absolute", right: 0, top: "60px" }}
      >
        <h1 className="text-white text-2xl mb-3 font-bold">Shopping Carts</h1>
        {/* Shopping Cart 1 */}

        <TempCart siteId={siteId} />
      </div>
    </div>
  );
}
